<template>
  <div>
    <template v-if="fullloading">
      <div class="text-center">
        <b-spinner class="m-5" label="Busy"></b-spinner>
      </div>
    </template>
    <template v-else>
      <div>
        <h1>{{ $lang("參加兒童及家庭成員") }}</h1>
        <p class="text-danger">{{ $lang("其中必須有兒童參與") }}</p>
        <b-form-checkbox v-model="showZhName" :disabled="true" :value="true">{{ $lang("沒有中文名") }}</b-form-checkbox>
      </div>
      <div>
        <b-form>
          <template v-for="(item, index) in childMembers">
            <item-form :usetype="5" :showZhName="showZhName" :key="item.key" class="dashed" :rules="rules"
              :index="index" :disabled="true" :value.sync="item" ref="form-item">
              <template v-if="false" v-slot:remove>
                <b-form-group horizontal>
                  <label slot="label"></label>
                  <b-btn variant="info" size="sm" class="del" @click="handleRemoveC(item)">
                    <i class="fa fa-trash-o" style="margin-right: 5px"></i>
                    {{ $lang("刪除") }}
                  </b-btn>
                </b-form-group>
              </template>
            </item-form>
          </template>
          <template v-for="item in members">
            <item-form :showZhName="showZhName" :key="item.key" class="dashed" :rules="rules" :disabled="true"
              :value.sync="item" ref="form-item">
              <template v-if="false" v-slot:remove>
                <b-form-group horizontal>
                  <label slot="label"></label>
                  <b-btn variant="info" size="sm" class="del" @click="handleRemove(item)">
                    <i class="fa fa-trash-o" style="margin-right:5px"></i>
                    {{ $lang("刪除") }}
                  </b-btn>
                </b-form-group>
              </template>
            </item-form>
          </template>
          <div class="form-footer dashed">
            <div v-if="readOnlyStatus == 1">{{ $lang("10021") }}</div>
            <div v-else-if="readOnlyStatus == 2">{{ $lang("1022") }}</div>
            <div>
              <b-btn variant="success btn-round" @click="$router.push({ name: 'family-day-2019' })">{{
                $lang("TITLE_RETURN_INDEX")
              }}</b-btn>
            </div>
          </div>
        </b-form>
      </div>
    </template>
  </div>
</template>

<script>
import { $apis } from "@/helper";
import ItemForm from "@/components/ItemForm";
import LaddaBtn from "@/components/ladda/Ladda";

export default {
  components: {
    ItemForm,
    LaddaBtn
  },
  data() {
    return {
      index: 3,
      showZhName: false,
      rules: {
        birth: {
          required: true,
          familyComing_age: [2015],
        },
        childBirth: {
          childBirth: [2016, 2024],
          required: true,
        },
        lastName: {
          required: true
        },
        firstName: {
          required: true
        },
        lastNameOther: {
          required: true
        },
        firstNameOther: {
          required: true
        },
        sex: {
          required: true
        },
        idType: {
          required: true
        },
        idNumber: {
          required: true,
          idNumber: true
        }
      },
      fullloading: false,
      loading: false,
      members: [
        {
          lastName: "",
          firstName: "",
          lastNameOther: "",
          firstNameOther: "",
          gender: "",
          bornAt: "",
          idType: 1,
          idNumber: ""
        },
        {
          lastName: "",
          firstName: "",
          lastNameOther: "",
          firstNameOther: "",
          gender: "",
          bornAt: "",
          idType: 1,
          idNumber: ""
        },
        {
          lastName: "",
          firstName: "",
          lastNameOther: "",
          firstNameOther: "",
          gender: "",
          bornAt: "",
          idType: 1,
          idNumber: ""
        }
      ],
      childMembers: [
        {
          lastName: "",
          firstName: "",
          lastNameOther: "",
          firstNameOther: "",
          gender: "",
          bornAt: "",
          idType: 1,
          idNumber: "",
          showZhName: false,
        },
      ],
      readOnlyStatus: 0
    };
  },
  methods: {
    computedList(members) {
      let list = [];
      members.forEach((item) => {
        if (item.idNumber) {
          list.push({
            showZhName: !item.showZhName,
            lastName: item.lastName,
            firstName: item.firstName,
            lastNameOther: item.lastNameOther,
            firstNameOther: item.firstNameOther,
            gender: item.gender,
            bornAt: item.bornAt,
            idType: item.idType,
            idNumber: item.idNumber,
            readOnlyStatus: item.readOnlyStatus,
          });
        } else {
          list.push({
            showZhName: !item.showZhName,
            lastName: item.lastName,
            firstName: item.firstName,
            lastNameOther: item.lastNameOther,
            firstNameOther: item.firstNameOther,
            gender: item.gender,
            bornAt: item.bornAt,
            readOnlyStatus: item.readOnlyStatus,
          });
        }

      });
      return list;
    },
    // 获取家庭成员列表
    getFamilyList() {
      this.fullloading = true;
      $apis.family
        .familyList()
        .then(resp => {
          //member
          let m = [];
          //childmember
          let cm = [];
          if (resp.data.members.length >= 3) {
            resp.data.members.forEach((item) => {
              if (item.is10AgeLater) {
                m.push(item);
              } else {
                cm.push(item);
              }
            });
            this.members = this.computedList(m);
            this.childMembers = this.computedList(cm);
          }

          this.readOnlyStatus = resp.data.readOnlyStatus;
          // this.showZhName = !resp.data.showZhName;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.fullloading = false;
        });
    }
  },

  created() {
    // 获取家庭成员列表
    this.getFamilyList();
  }
};
</script>
